import React from 'react';
// components
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';
import AddServiceForm from './AddServiceForm';

// icons
import icon from '../../brand/generated/sidebar/services.svg';
import { useNavigate } from 'react-router-dom';

const AddService = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header title="ÐÐ¾Ð²Ð°Ñ ÑÑÐ»ÑÐ³Ð°" icon={icon} />
      <Breadcrumbs navigate={'/services'} link={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÑÐ»ÑÐ³Ð¸'} currentPage={'ÐÐ¾Ð²Ð°Ñ ÑÑÐ»ÑÐ³Ð°'} />
      <AddServiceForm
        onSuccess={() => {
          setTimeout(() => {
            navigate('/services');
          }, 1000);
        }}
      />
    </>
  );
};

export default AddService;
